<template>
  <div
    class="navigation-buttons"
    :class="{
      'navigation-buttons__move-down': isModelviewShowing,
      'navigation-buttons__move-down-more': isPlanviewShowing
    }"
  >
    <LevelOfDetailControl v-if="isMapviewShowing" />
    <PitchControl v-if="isMapviewShowing" />
    <BearingControl v-if="isPlanviewShowing" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LevelOfDetailControl from './LevelOfDetailControl.vue'
import PitchControl from './PitchControl.vue'
import BearingControl from './BearingControl.vue'
export default {
  name: 'CustomControls',
  components: {
    PitchControl,
    BearingControl,
    LevelOfDetailControl
  },
  computed: {
    ...mapGetters({
      isPlanviewShowing: 'isPlanviewShowing',
      isMapviewShowing: 'isMapviewShowing',
      isModelviewShowing: 'isModelviewShowing'
    })
  }
}
</script>

<style lang="scss" scoped>
@use 'src/design-system/design-tokens/variables.scss';
@import 'src/styles/variables.scss';

.navigation-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  position: absolute;
  right: 8px;
  bottom: 204px; // Total height of current Mapbox scale and four buttons incl. their margins
  margin-bottom: 10px;
  z-index: variables.$z-index-map-buttons;

  &__button {
    margin: 0px 0px 10px 0px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__move-down {
    bottom: 169px; // Total height of current Mapbox scale and three buttons incl. their margins
    &-more {
      bottom: 134px; // Total height of current Mapbox scale and two buttons incl. their margins
    }
  }
}
@media screen and (max-width: 1024px) {
  .navigation-buttons {
    display: none;
    margin-bottom: 0;
    right: -5px;
  }
}
</style>
